<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'InputBox',
  props: {
    text: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      message: this.text,
      showError: false
    };
  },
  methods: {
    changeText () {
      this.$emit('change', this.message);
      if (this.message && this.message.length >= 200) {
        this.showError = true;
      } else {
        this.showError = false;
      }
    }
  }
});
</script>

<template>
  <div class="input-box">
    <textarea
      v-model="message"
      maxlength="200"
      @input="changeText"
    ></textarea>
    <p v-if="showError" class="error">{{ $t('Character limit (200) reached!') }}</p>
  </div>
</template>

<style lang="scss" scoped>
.input-box {
  height: 20vh;
  textarea {
    height: 100%;
    width: 100%;
    resize: none;
    box-sizing: border-box;
    padding: 5px !important;
    color: $survey-text-color;
    font-family: $font-family;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;
  }
  .error {
    color: red;
    font-size: 12px;
    margin-top: 5px;
    text-align: center;
  }
}
</style>
